import { apiSlice } from '@/api/api.slice.tsx';
import {
  PaginatedRequestV2,
  PaginatedResponse,
} from '@arsnovasystems/ars-front-lib';

/**
 * A single partner payment method — mirrors the backend
 * `StripePaymentMethodPartnerDto`. These are the `data` items of the
 * `CollectionResponseObjectDto` returned by `PaymentController::getPaymentMethods`.
 * Nullable PHP fields serialize as `null`.
 */
export interface PartnerPaymentMethod {
  id: string;
  stripePaymentMethodPartnerId: number | null;
  stripeId: string | null;
  creationDate: string;
  type: string;
  cardBrand: string | null;
  cardCountryCode: string | null;
  cardExpMonth: number;
  cardExpYear: number;
  cardLast4: string | null;
  sepaDebitBankCode: string | null;
  sepaDebitBranchCode: string | null;
  sepaDebitCountryCode: string | null;
  sepaDebitFingerprint: string | null;
  sepaDebitLast4: string | null;
  virtualIban: string | null;
  virtualBic: string | null;
  virtualIbanCountryCode: string | null;
  virtualUsAccountNumber: string | null;
  virtualUsRoutingNumber: string | null;
  isDefault: boolean;
}

const curr = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPartnerPaymentMethods: builder.query<
      PaginatedResponse<PartnerPaymentMethod>,
      PaginatedRequestV2
    >({
      query: ({ paginate, search }) => ({
        method: 'POST',
        url: `/payment-methods`,
        body: { paginate, search },
      }),
      providesTags: ['PaymentMethod'],
    }),
  }),
});

export const { useGetPartnerPaymentMethodsQuery } = curr;
